"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = require("styled-components");
var GlobalHttpErrorPage_component_1 = require("@greatmindsorg/atomic-ui-lib-lts/dist/components/organisms/GlobalHttpErrorPage/GlobalHttpErrorPage.component");
var baseTheme_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme"));
var api_1 = require("../../../api");
var NotFound = function () {
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: baseTheme_1.default, children: (0, jsx_runtime_1.jsx)(GlobalHttpErrorPage_component_1.GlobalHttpErrorPage, { errorCodeVariant: 404, customErrorMessage: t('notFound.message'), additionalInstructionsMessage: t('notFound.title'), actions: [
                    {
                        actionMsg: 'Go Back',
                        variant: 'primary',
                        actionCallback: function () { return window.history.back(); },
                    },
                    {
                        actionMsg: 'Help Center',
                        variant: 'primary',
                        actionCallback: function () { return window.open(api_1.HELP_CENTER); },
                    },
                ] }) }) }));
};
exports.NotFound = NotFound;
exports.default = exports.NotFound;
